import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Instagram, Youtube } from "lucide-react";
import { imgUrl } from "@/lib/api";

function ytEmbed(url) {
  if (!url) return null;
  try {
    const u = new URL(url);
    let id = "";
    if (u.hostname.includes("youtu.be")) id = u.pathname.slice(1);
    else if (u.searchParams.get("v")) id = u.searchParams.get("v");
    else if (u.pathname.includes("/embed/")) id = u.pathname.split("/embed/")[1];
    return id ? `https://www.youtube.com/embed/${id}` : null;
  } catch { return null; }
}

export default function SocialSection() {
  const [s, setS] = useState({});
  useEffect(() => { api.get("/settings").then(({ data }) => setS(data)).catch(() => {}); }, []);

  const embed = ytEmbed(s.youtube_url);
  const fallback = s.instagram_fallback || [];

  return (
    <section className="max-w-7xl mx-auto px-6 lg:px-10 py-24" data-testid="social-section">
      <p className="text-xs tracking-[0.2em] uppercase font-bold text-[#C1272D] mb-3">Follow the journey</p>
      <h2 className="font-display text-4xl sm:text-5xl font-semibold tracking-tight text-[#1F4D2E] mb-14">Straight from the home</h2>

      <div className="grid grid-cols-1 lg:grid-cols-12 gap-8">
        <div className="lg:col-span-7">
          <div className="aspect-video bg-[#1F4D2E] overflow-hidden">
            {embed ? (
              <iframe title="Latest video" src={embed} className="w-full h-full" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen data-testid="youtube-embed" />
            ) : (
              <div className="w-full h-full flex items-center justify-center text-[#E7EDE2]/60 gap-2"><Youtube /> Video coming soon</div>
            )}
          </div>
        </div>
        <div className="lg:col-span-5">
          <div className="flex items-center gap-2 mb-4 text-[#1F4D2E] font-semibold"><Instagram size={20} /> On Instagram</div>
          <div className="grid grid-cols-3 gap-3">
            {fallback.length > 0 ? fallback.map((f, i) => (
              <a key={i} href={f.link || s.social_instagram || "#"} target="_blank" rel="noopener noreferrer" data-testid={`instagram-tile-${i}`}
                className="aspect-square overflow-hidden group block">
                <img src={imgUrl(f.image_url)} alt="Instagram post" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
              </a>
            )) : (
              <div className="col-span-3 text-[#4F6B54] text-sm py-8 text-center border border-[#1F4D2E]/10">Instagram feed will appear here.</div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
